var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            width: "1000px",
            "close-on-click-modal": false,
            "show-close": false,
            top: "5vh",
            "custom-class": "make-invoice-dialog"
          }
        },
        [
          _c(
            "div",
            { staticClass: "tabs-container", staticStyle: { padding: "0" } },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { width: "100%" },
                  attrs: { lazy: true, type: "card" },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("Invoice.invoice_invoiceContent"),
                        name: "makeInvoice"
                      }
                    },
                    [
                      _vm.properties.invoice.ar &&
                      [0, 1, 4].includes(_vm.properties.invoice.invoiceType)
                        ? _c(
                            "div",
                            {
                              staticStyle: { padding: "10px 10px 10px 20px" },
                              attrs: { id: "invoiceIncomeBoard" }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "justify-content": "center",
                                    "font-size": "18px"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Sp1")))]
                              ),
                              _c(
                                "el-form",
                                {
                                  staticStyle: { "margin-top": "4px" },
                                  attrs: {
                                    inline: true,
                                    "label-width": "60px",
                                    "label-position": "left"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "el-form-item-wrapper" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w250",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_PayUnit"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "1",
                                              disabled: _vm.locked
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice.title,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "title",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.title"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w190",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_InvoiceNo"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "2",
                                              disabled:
                                                !_vm.properties
                                                  .invoiceNoEditable ||
                                                _vm.invoiceReadonly ||
                                                [
                                                  "overseaBilling",
                                                  "internalBillInfo"
                                                ].includes(_vm.viewSource) ||
                                                _vm.approvalLocked
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .invoiceNo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "invoiceNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.invoiceNo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-date-w190",
                                          attrs: {
                                            label: _vm.$t(
                                              "Invoice.invoice_invoiceDate"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticClass:
                                              "el-form-item__content",
                                            attrs: {
                                              no: "3",
                                              type: "date",
                                              clearable: false,
                                              disabled: _vm.locked
                                            },
                                            on: {
                                              change: _vm.invoiceDateChange
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .invoiceDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "invoiceDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.invoiceDate"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "el-form-item-wrapper" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w110",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_OriginalCurrency"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "4", disabled: true },
                                            model: {
                                              value: _vm.chargeCurrency,
                                              callback: function($$v) {
                                                _vm.chargeCurrency = $$v
                                              },
                                              expression: "chargeCurrency"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w110",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_InvoicingCurrency"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "5", disabled: true },
                                            model: {
                                              value:
                                                _vm.properties.invoice.currency,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "currency",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.currency"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w130",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_ExchangeRate"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "6", disabled: true },
                                            model: {
                                              value: _vm.rate,
                                              callback: function($$v) {
                                                _vm.rate = $$v
                                              },
                                              expression: "rate"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm.approvalEditable
                                        ? _c(
                                            "el-form-item",
                                            {
                                              staticClass: "el-form-item-w250",
                                              attrs: {
                                                label: _vm.$t(
                                                  "CargoMsg.Cargo_OurBank"
                                                )
                                              }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                attrs: {
                                                  no: "7",
                                                  filterable: "",
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .static_data_BankAccount,
                                                  cache: false,
                                                  "method-params": {
                                                    officeUuid:
                                                      _vm.$store.getters
                                                        .currentOfficeUuid
                                                  },
                                                  "default-value":
                                                    _vm.ourBankAccountId || "",
                                                  "static-options":
                                                    _vm.ourBankAccountArray,
                                                  disabled:
                                                    _vm.locked ||
                                                    _vm.ourBankAccountAutoLocked,
                                                  "options-width": "450px"
                                                },
                                                on: {
                                                  parentCallBack:
                                                    _vm.getBankAccountFromChild
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "el-form-item",
                                            {
                                              staticClass: "el-form-item-w250",
                                              attrs: {
                                                label: _vm.$t(
                                                  "CargoMsg.Cargo_OurBank"
                                                )
                                              }
                                            },
                                            [
                                              _c("cargo-advance-select", {
                                                attrs: {
                                                  no: "7",
                                                  filterable: "",
                                                  "select-type":
                                                    _vm.selectTypeNames
                                                      .static_data_BankAccount,
                                                  cache: false,
                                                  "method-params": {
                                                    officeId:
                                                      _vm.properties.invoice
                                                        .branchId
                                                  },
                                                  "default-value":
                                                    _vm.ourBankAccountId || "",
                                                  "static-options":
                                                    _vm.ourBankAccountArray,
                                                  disabled:
                                                    _vm.locked ||
                                                    _vm.ourBankAccountAutoLocked,
                                                  "options-width": "450px"
                                                },
                                                on: {
                                                  parentCallBack:
                                                    _vm.getBankAccountFromChild
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w190",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_OurAccount"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "8", disabled: true },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .bankAccount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "bankAccount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.bankAccount"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "el-form-item-wrapper" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w150",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_SubscribePOL"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "9", disabled: true },
                                            model: {
                                              value: _vm.pol,
                                              callback: function($$v) {
                                                _vm.pol = $$v
                                              },
                                              expression: "pol"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w150",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_PortOfDischarge"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "10", disabled: true },
                                            model: {
                                              value: _vm.pod,
                                              callback: function($$v) {
                                                _vm.pod = $$v
                                              },
                                              expression: "pod"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w150",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_Destination"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "11", disabled: true },
                                            model: {
                                              value: _vm.pod2,
                                              callback: function($$v) {
                                                _vm.pod2 = $$v
                                              },
                                              expression: "pod2"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-date-w190",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_SailingDate"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticClass:
                                              "el-form-item__content",
                                            attrs: {
                                              no: "12",
                                              type: "date",
                                              disabled: true
                                            },
                                            model: {
                                              value: _vm.properties.invoice.etd,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "etd",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.etd"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-date-w190",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_ArrivalDate"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticClass:
                                              "el-form-item__content",
                                            attrs: {
                                              no: "13",
                                              type: "date",
                                              disabled: true
                                            },
                                            model: {
                                              value: _vm.properties.invoice.eta,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "eta",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.eta"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "el-form-item-wrapper" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w320",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_InvoicingRequirements"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "14", disabled: true },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .invoiceDemand,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "invoiceDemand",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.invoiceDemand"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass:
                                            "el-form-item-label65-w250",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_VesselAndVoyage"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "15",
                                              disabled: _vm.locked
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .vesselVoyage,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "vesselVoyage",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.vesselVoyage"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "" } },
                                        [
                                          _c(
                                            "el-radio-group",
                                            {
                                              attrs: { no: "16" },
                                              on: {
                                                change: _vm.onMergeTypeChange
                                              },
                                              model: {
                                                value:
                                                  _vm.properties
                                                    .rbgShowChargeDetail,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.properties,
                                                    "rbgShowChargeDetail",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "properties.rbgShowChargeDetail"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-radio",
                                                {
                                                  attrs: {
                                                    id: "rbSole",
                                                    label: "detail",
                                                    disabled:
                                                      _vm.lockedWithoutBpm
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Sp17"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-radio",
                                                {
                                                  attrs: {
                                                    id: "rbMerge",
                                                    label: "merge",
                                                    disabled:
                                                      _vm.lockedWithoutBpm
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Sp18"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "el-form-item-wrapper" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass:
                                            "el-form-item-textarea-w140",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_Cargo"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "17",
                                              type: "textarea",
                                              disabled: true
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .partCargo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "partCargo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.partCargo"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass:
                                            "el-form-item-textarea-w100",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_ChargeName"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "18",
                                              type: "textarea",
                                              disabled: _vm.locked
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .partChargeName,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "partChargeName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.partChargeName"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass:
                                            "el-form-item-textarea-w80",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_AmountNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "19",
                                              type: "textarea",
                                              disabled: true
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .partQuantity,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "partQuantity",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.partQuantity"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass:
                                            "el-form-item-textarea-w80",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_UnitPrice"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "20",
                                              type: "textarea",
                                              disabled: true
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .partUnitPrice,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "partUnitPrice",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.partUnitPrice"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass:
                                            "el-form-item-textarea-w80",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_OriginalAmount"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "21",
                                              type: "textarea",
                                              disabled: true
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .partAmount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "partAmount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.partAmount"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass:
                                            "el-form-item-textarea-w80",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_MonetaryEquivalent"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "22",
                                              type: "textarea",
                                              disabled: true
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .partAmount2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "partAmount2",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.partAmount2"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass:
                                            "el-form-item-textarea-w150",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_Remarks"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "23",
                                              type: "textarea",
                                              disabled: _vm.locked
                                            },
                                            on: {
                                              input:
                                                _vm.markInvoiceRemarkModified
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice.remark,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "remark",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.remark"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass:
                                            "el-form-item-textarea-w100",
                                          attrs: {
                                            label: _vm.$t("CargoMsg.Cargo_Sp24")
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "24",
                                              type: "textarea",
                                              disabled: _vm.locked
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice.remark2,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "remark2",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.remark2"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "el-form-item-wrapper" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w210",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_TotalAmount"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "25", disabled: true },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .chineseAmount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "chineseAmount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.chineseAmount"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w190",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_AmountTo"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "26", disabled: true },
                                            model: {
                                              value: _vm.amount,
                                              callback: function($$v) {
                                                _vm.amount = $$v
                                              },
                                              expression: "amount"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "el-form-item-wrapper" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w210",
                                          attrs: {
                                            label: _vm.$t("CargoMsg.Cargo_Sp27")
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              id: "tiCompany",
                                              no: "27",
                                              disabled: true
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w190",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_Recheck"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "28", disabled: true },
                                            model: {
                                              value:
                                                _vm.properties.invoice.auditor,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "auditor",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.auditor"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "el-form-item-w230",
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_TaxationNbr"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "29",
                                              disabled: _vm.locked
                                            },
                                            model: {
                                              value:
                                                _vm.properties.invoice
                                                  .taxAccount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.properties.invoice,
                                                  "taxAccount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "properties.invoice.taxAccount"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.properties.invoice.ar &&
                      [2, 3].includes(_vm.properties.invoice.invoiceType) &&
                      !_vm.properties.isEasyInoivceVietnam
                        ? _c(
                            "div",
                            { attrs: { id: "invoiceAddValueBoard" } },
                            [
                              _c(
                                "el-form",
                                {
                                  staticClass: "vatInvoiceForm",
                                  attrs: {
                                    "label-width": "100px",
                                    "label-position": "right"
                                  }
                                },
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-header",
                                      attrs: { type: "flex", gutter: 10 }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "left",
                                          attrs: { span: 7 }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t(
                                                    "Invoice.invoice_makeType"
                                                  ) + "："
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.makeType))
                                              ]),
                                              _vm.properties.invoice
                                                .invoiceState === 1 ||
                                              _vm.properties.invoice
                                                .invoiceState === 2
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "5px",
                                                        color: "red",
                                                        "font-size": "16px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.redPunch)
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t(
                                                    "Invoice.invoice_invoiceStatus"
                                                  ) + "："
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.isPrinted))
                                              ]),
                                              _vm.properties.invoice
                                                .makeType === 0 &&
                                              _vm.properties.invoice
                                                .invoiceType === 3 &&
                                              _vm.properties.invoice
                                                .invoiceState === 2
                                                ? _c("el-input", {
                                                    attrs: {
                                                      no: "30",
                                                      placeholder: _vm.$t(
                                                        "CargoMsg.Cargo_PleaseEnterScarletLetterNumber"
                                                      ),
                                                      max: "20",
                                                      disabled:
                                                        !_vm.enabledCnnoticeNo ||
                                                        _vm.approvalLocked
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .cnnoticeNo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "cnnoticeNo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.cnnoticeNo"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "center",
                                          attrs: { span: 10 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { width: "100%" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "22px",
                                                    color: "red",
                                                    display: "block",
                                                    "text-align": "center"
                                                  },
                                                  attrs: { id: "lbInvoiceType" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.lbInvoiceType)
                                                  )
                                                ]
                                              ),
                                              _c("div", {
                                                staticStyle: {
                                                  "padding-top": "6px",
                                                  width: "100%",
                                                  "border-bottom":
                                                    "1px solid red"
                                                }
                                              }),
                                              _c("div", {
                                                staticStyle: {
                                                  "padding-top": "3px",
                                                  width: "100%",
                                                  "border-bottom":
                                                    "1px solid red"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "right",
                                          attrs: { span: 7 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_InvoiceNo"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      no: "31",
                                                      disabled:
                                                        !_vm.properties
                                                          .invoiceNoEditable ||
                                                        _vm.invoiceReadonly ||
                                                        [
                                                          "overseaBilling",
                                                          "internalBillInfo"
                                                        ].includes(
                                                          _vm.viewSource
                                                        ) ||
                                                        _vm.approvalLocked
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .invoiceNo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "invoiceNo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.invoiceNo"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_InvoiceDate"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-date-picker", {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      no: "32",
                                                      type: "date",
                                                      clearable: false,
                                                      disabled: _vm.locked
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.invoiceDateChange
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .invoiceDate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "invoiceDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.invoiceDate"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          attrs: { span: 1 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title-vertical" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_PurchasingUnit"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          staticStyle: { padding: "5px 5px" },
                                          attrs: { span: 12 }
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { gutter: 10 }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Name"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c(
                                                        "cargo-advance-select",
                                                        {
                                                          attrs: {
                                                            no: "33",
                                                            "select-type":
                                                              _vm
                                                                .selectTypeNames
                                                                .static_data_Title,
                                                            "allow-create":
                                                              !_vm.arSettlementUnitOptional ||
                                                              !_vm.properties
                                                                .invoice.ar,
                                                            filterable: "",
                                                            cache: false,
                                                            disabled:
                                                              _vm.locked,
                                                            "default-value":
                                                              _vm.properties
                                                                .invoice.title,
                                                            "static-options":
                                                              _vm.titleArray
                                                          },
                                                          on: {
                                                            parentCallBack:
                                                              _vm.titleChangeEvent
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c("line-label", {
                                                    attrs: {
                                                      slot: "label",
                                                      label: _vm.$t(
                                                        "CargoMsg.Cargo_RegistrationNumber"
                                                      )
                                                    },
                                                    slot: "label"
                                                  }),
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "34",
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .buyerTaxAccount,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "buyerTaxAccount",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.buyerTaxAccount"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_AddressTelNo"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 12,
                                                        title:
                                                          _vm.properties.invoice
                                                            .buyerAddress
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "35",
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .buyerAddress,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "buyerAddress",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.buyerAddress"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 12,
                                                        title:
                                                          _vm.properties.invoice
                                                            .buyerTelephone
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "36",
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .buyerTelephone,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "buyerTelephone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.buyerTelephone"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm.bankModeAvailable
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticClass: "bank-mode"
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            slot: "label",
                                                            no: "37",
                                                            disabled: _vm.locked
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.buyerBankModeChange
                                                          },
                                                          slot: "label",
                                                          model: {
                                                            value:
                                                              _vm.properties
                                                                .invoice
                                                                .buyerBankMode,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.properties
                                                                  .invoice,
                                                                "buyerBankMode",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "properties.invoice.buyerBankMode"
                                                          }
                                                        },
                                                        [
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "CargoMsg.Cargo_BankAccountNo"
                                                              ),
                                                              value: 0
                                                            }
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "CargoMsg.Cargo_DepositBankAndAccountNo"
                                                              ),
                                                              value: 1
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm.properties.invoice
                                                        .buyerBankMode === 1
                                                        ? _c(
                                                            "el-col",
                                                            {
                                                              attrs: {
                                                                span: 24,
                                                                title:
                                                                  _vm.properties
                                                                    .invoice
                                                                    .buyerDepositBankAccount
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "cargo-rich-textarea",
                                                                {
                                                                  ref:
                                                                    "buyerDepositBankAccount",
                                                                  staticStyle: {
                                                                    "min-height":
                                                                      "45px"
                                                                  },
                                                                  attrs: {
                                                                    no: "38",
                                                                    value:
                                                                      _vm
                                                                        .properties
                                                                        .invoice
                                                                        .buyerDepositBankAccount,
                                                                    disabled:
                                                                      _vm.locked,
                                                                    "text-chars": 0,
                                                                    "warning-count": -1
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      _vm.buyerDepositBankAccountChange
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 12,
                                                                  title:
                                                                    _vm
                                                                      .properties
                                                                      .invoice
                                                                      .buyerBank
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "cargo-advance-select",
                                                                  {
                                                                    attrs: {
                                                                      no: "39",
                                                                      "select-type":
                                                                        _vm
                                                                          .selectTypeNames
                                                                          .static_data_TitleBank,
                                                                      "allow-create": true,
                                                                      filterable:
                                                                        "",
                                                                      cache: false,
                                                                      disabled:
                                                                        _vm.locked,
                                                                      "tag-value":
                                                                        "uuid",
                                                                      "default-value":
                                                                        _vm.buyerBankUuid,
                                                                      "static-options":
                                                                        _vm.titleBankArray
                                                                    },
                                                                    on: {
                                                                      parentCallBack:
                                                                        _vm.getBankCusFromChild
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 12,
                                                                  title:
                                                                    _vm
                                                                      .properties
                                                                      .invoice
                                                                      .buyerBankAccount
                                                                }
                                                              },
                                                              [
                                                                _c("el-input", {
                                                                  attrs: {
                                                                    no: "40",
                                                                    disabled:
                                                                      _vm.locked
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .properties
                                                                        .invoice
                                                                        .buyerBankAccount,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .properties
                                                                          .invoice,
                                                                        "buyerBankAccount",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "properties.invoice.buyerBankAccount"
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              !_vm.bankModeAvailable
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "CargoMsg.Cargo_BankAccountNo"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-col",
                                                        {
                                                          attrs: {
                                                            span: 12,
                                                            title:
                                                              _vm.properties
                                                                .invoice
                                                                .buyerBank
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "cargo-advance-select",
                                                            {
                                                              attrs: {
                                                                no: "41",
                                                                "select-type":
                                                                  _vm
                                                                    .selectTypeNames
                                                                    .static_data_TitleBank,
                                                                "allow-create": true,
                                                                filterable: "",
                                                                cache: false,
                                                                disabled:
                                                                  _vm.locked,
                                                                "tag-value":
                                                                  "uuid",
                                                                "default-value":
                                                                  _vm.buyerBankUuid,
                                                                "static-options":
                                                                  _vm.titleBankArray
                                                              },
                                                              on: {
                                                                parentCallBack:
                                                                  _vm.getBankCusFromChild
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-col",
                                                        {
                                                          attrs: {
                                                            span: 12,
                                                            title:
                                                              _vm.properties
                                                                .invoice
                                                                .buyerBankAccount
                                                          }
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              no: "42",
                                                              disabled:
                                                                _vm.locked
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.properties
                                                                  .invoice
                                                                  .buyerBankAccount,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.properties
                                                                    .invoice,
                                                                  "buyerBankAccount",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "properties.invoice.buyerBankAccount"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          attrs: { span: 1 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title-vertical" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_PasswordField"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c("el-col", {
                                        staticClass: "red-both-top-border-w1",
                                        attrs: { span: 10 }
                                      })
                                    ],
                                    1
                                  ),
                                  !_vm.locked
                                    ? _c(
                                        "el-row",
                                        {
                                          staticClass: "vatInvoiceForm-section",
                                          attrs: { type: "flex" }
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass:
                                                "red-both-top-border-w1",
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "flex-end"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      attrs: {
                                                        disabled: _vm.lookView,
                                                        no: "43"
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.rbgShowChargeDetailChangeHandler
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.properties
                                                            .rbgShowChargeDetail,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.properties,
                                                            "rbgShowChargeDetail",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "properties.rbgShowChargeDetail"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px"
                                                          },
                                                          attrs: {
                                                            label: "merge"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_Sp18"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px"
                                                          },
                                                          attrs: {
                                                            label: "detail",
                                                            disabled:
                                                              !_vm.properties
                                                                .showChargeDetailByInvoice ||
                                                              _vm.approvalLocked
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_ShowDetails"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-button-group",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value: !_vm.lookView,
                                                          expression:
                                                            "!lookView"
                                                        }
                                                      ]
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          on: {
                                                            click:
                                                              _vm.addInvoiceItemHandler
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_Add"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          on: {
                                                            click:
                                                              _vm.removeInvoiceItemHandler
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_Delete"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name:
                                                                "permission",
                                                              rawName:
                                                                "v-permission",
                                                              value: [
                                                                "button_ACInvoice_saveInvoiceAmount"
                                                              ],
                                                              expression:
                                                                "['button_ACInvoice_saveInvoiceAmount']"
                                                            }
                                                          ],
                                                          on: {
                                                            click:
                                                              _vm.checkInvoiceNoSaveAndCalcAmountHandler
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_Reflush"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-both-top-border-w1"
                                        },
                                        [
                                          _c("cargo-ag-grid", {
                                            staticStyle: {
                                              height: "123px",
                                              width: "100%"
                                            },
                                            attrs: {
                                              "show-side-bar": false,
                                              "grid-params":
                                                _vm.vatInvoiceGrid.gridParams,
                                              "grid-options":
                                                _vm.vatInvoiceGrid.gridOptions,
                                              "column-defs":
                                                _vm.vatInvoiceGridColumnDefs,
                                              "row-data":
                                                _vm.vatInvoiceGridRowData,
                                              "auto-fit-content": false
                                            },
                                            on: {
                                              "update:gridParams": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.vatInvoiceGrid,
                                                  "gridParams",
                                                  $event
                                                )
                                              },
                                              "update:grid-params": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.vatInvoiceGrid,
                                                  "gridParams",
                                                  $event
                                                )
                                              },
                                              gridReady: function(params) {
                                                return (_vm.gridApi =
                                                  params.api)
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          attrs: {
                                            span: _vm.$selectByLang(4, 5)
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title-horizontal" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_TotalPriceWithTaxInWords"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-both-top-border-w1",
                                          attrs: {
                                            span: _vm.$selectByLang(20, 19)
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    padding: "0 10px"
                                                  },
                                                  attrs: {
                                                    label: "",
                                                    "label-width": "0"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "286px"
                                                    },
                                                    attrs: {
                                                      no: "44",
                                                      disabled: true
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .chineseAmount,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "chineseAmount",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.chineseAmount"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    display: "flex"
                                                  },
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_LowerCase"
                                                    ),
                                                    "label-width": "50"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "140px"
                                                    },
                                                    attrs: {
                                                      no: "45",
                                                      disabled: true
                                                    },
                                                    model: {
                                                      value: _vm.amount,
                                                      callback: function($$v) {
                                                        _vm.amount = $$v
                                                      },
                                                      expression: "amount"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          attrs: { span: 1 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title-vertical" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_SellTitle"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          staticStyle: { padding: "5px 5px" },
                                          attrs: { span: 12 }
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { gutter: 10 }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Name"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c(
                                                        "cargo-advance-select",
                                                        {
                                                          attrs: {
                                                            no: "46",
                                                            "select-type":
                                                              _vm
                                                                .selectTypeNames
                                                                .static_data_InvoiceTitle,
                                                            "allow-create": true,
                                                            filterable: "",
                                                            cache: false,
                                                            disabled:
                                                              _vm.locked ||
                                                              _vm.ourInvoiceTitleLocked,
                                                            "default-value":
                                                              _vm.properties
                                                                .invoice
                                                                .sellTitle,
                                                            "static-options":
                                                              _vm.ourInvoiceTitleArray
                                                          },
                                                          on: {
                                                            parentCallBack:
                                                              _vm.ourTitleChangeEvent
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c("line-label", {
                                                    attrs: {
                                                      slot: "label",
                                                      label: _vm.$t(
                                                        "CargoMsg.Cargo_RegistrationNumber"
                                                      )
                                                    },
                                                    slot: "label"
                                                  }),
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "47",
                                                          disabled:
                                                            _vm.locked ||
                                                            _vm.ourInvoiceTitleLocked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .taxAccount,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "taxAccount",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.taxAccount"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_AddressTelNo"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 12,
                                                        title:
                                                          _vm.properties.invoice
                                                            .address
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "48",
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice.address,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "address",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.address"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 12,
                                                        title:
                                                          _vm.properties.invoice
                                                            .telephone
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "49",
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .telephone,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "telephone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.telephone"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm.bankModeAvailable
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticClass: "bank-mode"
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            slot: "label",
                                                            no: "50",
                                                            disabled: _vm.locked
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.sellerBankModeChange
                                                          },
                                                          slot: "label",
                                                          model: {
                                                            value:
                                                              _vm.properties
                                                                .invoice
                                                                .sellerBankMode,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.properties
                                                                  .invoice,
                                                                "sellerBankMode",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "properties.invoice.sellerBankMode"
                                                          }
                                                        },
                                                        [
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "CargoMsg.Cargo_BankAccountNo"
                                                              ),
                                                              value: 0
                                                            }
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "CargoMsg.Cargo_DepositBankAndAccountNo"
                                                              ),
                                                              value: 1
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm.properties.invoice
                                                        .sellerBankMode === 1
                                                        ? _c(
                                                            "el-col",
                                                            {
                                                              attrs: {
                                                                span: 24,
                                                                title:
                                                                  _vm.properties
                                                                    .invoice
                                                                    .sellerDepositBankAccount
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "cargo-rich-textarea",
                                                                {
                                                                  ref:
                                                                    "sellerDepositBankAccount",
                                                                  staticStyle: {
                                                                    "min-height":
                                                                      "45px"
                                                                  },
                                                                  attrs: {
                                                                    id:
                                                                      "txtAccountNo",
                                                                    no: "51",
                                                                    value:
                                                                      _vm
                                                                        .properties
                                                                        .invoice
                                                                        .sellerDepositBankAccount,
                                                                    disabled:
                                                                      _vm.locked,
                                                                    "text-chars": 0,
                                                                    "warning-count": -1
                                                                  },
                                                                  on: {
                                                                    change:
                                                                      _vm.sellerDepositBankAccountChange
                                                                  }
                                                                }
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        : [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 12,
                                                                  title: _vm.getOurBankName()
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "cargo-advance-select",
                                                                  {
                                                                    attrs: {
                                                                      no: "52",
                                                                      filterable:
                                                                        "",
                                                                      "select-type":
                                                                        _vm
                                                                          .selectTypeNames
                                                                          .static_data_BankAccount,
                                                                      cache: false,
                                                                      "method-params": {
                                                                        officeUuid:
                                                                          _vm
                                                                            .$store
                                                                            .getters
                                                                            .currentOfficeUuid
                                                                      },
                                                                      "default-value":
                                                                        _vm.ourBankAccountId ||
                                                                        "",
                                                                      "static-options":
                                                                        _vm.ourBankAccountArray,
                                                                      disabled:
                                                                        _vm.locked ||
                                                                        _vm.ourBankAccountAutoLocked,
                                                                      "options-width":
                                                                        "450px"
                                                                    },
                                                                    on: {
                                                                      parentCallBack:
                                                                        _vm.getBankAccountFromChild
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 12,
                                                                  title:
                                                                    _vm
                                                                      .properties
                                                                      .invoice
                                                                      .bankAccount
                                                                }
                                                              },
                                                              [
                                                                _c("el-input", {
                                                                  attrs: {
                                                                    id:
                                                                      "txtAccountNo",
                                                                    no: "53",
                                                                    disabled: true
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .properties
                                                                        .invoice
                                                                        .bankAccount,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .properties
                                                                          .invoice,
                                                                        "bankAccount",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "properties.invoice.bankAccount"
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              !_vm.bankModeAvailable
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "CargoMsg.Cargo_BankAccountNo"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-col",
                                                        {
                                                          attrs: {
                                                            span: 12,
                                                            title: _vm.getOurBankName()
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "cargo-advance-select",
                                                            {
                                                              attrs: {
                                                                no: "54",
                                                                filterable: "",
                                                                "select-type":
                                                                  _vm
                                                                    .selectTypeNames
                                                                    .static_data_BankAccount,
                                                                cache: false,
                                                                "method-params": {
                                                                  officeUuid:
                                                                    _vm.$store
                                                                      .getters
                                                                      .currentOfficeUuid
                                                                },
                                                                "default-value":
                                                                  _vm.ourBankAccountId ||
                                                                  "",
                                                                "static-options":
                                                                  _vm.ourBankAccountArray,
                                                                disabled:
                                                                  _vm.locked ||
                                                                  _vm.ourBankAccountAutoLocked,
                                                                "options-width":
                                                                  "450px"
                                                              },
                                                              on: {
                                                                parentCallBack:
                                                                  _vm.getBankAccountFromChild
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-col",
                                                        {
                                                          attrs: {
                                                            span: 12,
                                                            title:
                                                              _vm.properties
                                                                .invoice
                                                                .bankAccount
                                                          }
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              id:
                                                                "txtAccountNo",
                                                              no: "55",
                                                              disabled: true
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.properties
                                                                  .invoice
                                                                  .bankAccount,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.properties
                                                                    .invoice,
                                                                  "bankAccount",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "properties.invoice.bankAccount"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          attrs: { span: 1 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title-vertical" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Remarks"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "title-vertical",
                                              style: _vm.$selectByLang(
                                                "",
                                                "overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
                                              ),
                                              attrs: {
                                                title: _vm.$selectByLang(
                                                  "",
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_FinancialRemarks"
                                                  )
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_FinancialRemarks"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-both-top-border-w1",
                                          attrs: { span: 10 }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass:
                                                "el-form-item-textarea-w-full",
                                              attrs: { "label-width": "0" }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  no: "56",
                                                  type: "textarea",
                                                  disabled: _vm.locked
                                                },
                                                on: {
                                                  input:
                                                    _vm.markInvoiceRemarkModified
                                                },
                                                model: {
                                                  value:
                                                    _vm.properties.invoice
                                                      .remark,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.properties.invoice,
                                                      "remark",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "properties.invoice.remark"
                                                }
                                              }),
                                              _c("el-input", {
                                                attrs: {
                                                  no: "57",
                                                  type: "textarea",
                                                  disabled: _vm.locked
                                                },
                                                model: {
                                                  value:
                                                    _vm.properties.invoice
                                                      .remark2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.properties.invoice,
                                                      "remark2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "properties.invoice.remark2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-top-border-w1",
                                          staticStyle: {
                                            "flex-direction": "row",
                                            "justify-content": "flex-start",
                                            "padding-top": "5px"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "el-form-item-w180",
                                              attrs: {
                                                label: _vm.$t(
                                                  "CargoMsg.Cargo_Payee"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  no: "58",
                                                  disabled: _vm.locked
                                                },
                                                model: {
                                                  value:
                                                    _vm.properties.invoice
                                                      .payee,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.properties.invoice,
                                                      "payee",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "properties.invoice.payee"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "el-form-item-w180",
                                              attrs: {
                                                label: _vm.$t(
                                                  "CargoMsg.Cargo_Recheck"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  no: "59",
                                                  disabled: _vm.locked
                                                },
                                                model: {
                                                  value:
                                                    _vm.properties.invoice
                                                      .auditor,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.properties.invoice,
                                                      "auditor",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "properties.invoice.auditor"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "el-form-item-w180",
                                              attrs: {
                                                label: _vm.$t(
                                                  "CargoMsg.Cargo_InvoicedBy"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  id: "txtInputBy",
                                                  no: "60",
                                                  disabled: true
                                                },
                                                model: {
                                                  value: _vm.inputBy,
                                                  callback: function($$v) {
                                                    _vm.inputBy = $$v
                                                  },
                                                  expression: "inputBy"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c("el-form-item", {
                                            staticStyle: {
                                              "padding-left": "2px"
                                            },
                                            attrs: {
                                              label: _vm.$t(
                                                "CargoMsg.Cargo_StampOfSalesUnit"
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.properties.invoice.ar &&
                      [2, 3].includes(_vm.properties.invoice.invoiceType) &&
                      _vm.properties.isEasyInoivceVietnam
                        ? _c(
                            "div",
                            { attrs: { id: "invoiceAddValueBoard" } },
                            [
                              _c(
                                "el-form",
                                {
                                  staticClass: "vatInvoiceFormVietnam",
                                  attrs: {
                                    "label-width": "160px",
                                    "label-position": "right"
                                  }
                                },
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-header",
                                      attrs: { type: "flex", gutter: 10 }
                                    },
                                    [
                                      _c("el-col", {
                                        staticClass: "left",
                                        attrs: { span: 7 }
                                      }),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "center",
                                          attrs: { span: 10 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { width: "100%" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "22px",
                                                    color: "red",
                                                    display: "block",
                                                    "text-align": "center"
                                                  },
                                                  attrs: { id: "lbInvoiceType" }
                                                },
                                                [
                                                  _vm._v(
                                                    "HÓA ĐƠN GIÁ TRỊ GIA TĂNG"
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "22px",
                                                    color: "red",
                                                    display: "block",
                                                    "text-align": "center"
                                                  },
                                                  attrs: { id: "lbMakeType" }
                                                },
                                                [_vm._v("(VAT INVOICE)")]
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "block",
                                                    "text-align": "center"
                                                  },
                                                  attrs: { id: "lbInvoiceDate" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.invoiceDateVietnam
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "right",
                                          attrs: { span: 7 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "Ký hiệu (Serial): "
                                                  }
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(_vm.patternVietnam)
                                                    )
                                                  ])
                                                ]
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: { label: "Số (No.): " }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      no: "121",
                                                      disabled:
                                                        !_vm.properties
                                                          .invoiceNoEditable ||
                                                        _vm.invoiceReadonly ||
                                                        [
                                                          "overseaBilling",
                                                          "internalBillInfo"
                                                        ].includes(
                                                          _vm.viewSource
                                                        ) ||
                                                        _vm.approvalLocked
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .invoiceNo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "invoiceNo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.invoiceNo"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "vietnam-top-border-w1",
                                          staticStyle: { padding: "5px 5px" },
                                          attrs: { span: 18 }
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { gutter: 10 }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label:
                                                      "Đơn vị bán hàng (Seller):"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c(
                                                        "cargo-advance-select",
                                                        {
                                                          attrs: {
                                                            no: "122",
                                                            "select-type":
                                                              _vm
                                                                .selectTypeNames
                                                                .static_data_InvoiceTitle,
                                                            "allow-create": true,
                                                            filterable: "",
                                                            cache: false,
                                                            disabled:
                                                              _vm.locked ||
                                                              _vm.ourInvoiceTitleLocked,
                                                            "default-value":
                                                              _vm.properties
                                                                .invoice
                                                                .sellTitle,
                                                            "static-options":
                                                              _vm.ourInvoiceTitleArray
                                                          },
                                                          on: {
                                                            parentCallBack:
                                                              _vm.ourTitleChangeEvent
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label:
                                                      "Mã số thuế (Tax code):"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "123",
                                                          disabled:
                                                            _vm.locked ||
                                                            _vm.ourInvoiceTitleLocked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .taxAccount,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "taxAccount",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.taxAccount"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "Địa chỉ (Address): "
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 18,
                                                        title:
                                                          _vm.properties.invoice
                                                            .address
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "124",
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice.address,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "address",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.address"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 6,
                                                        title:
                                                          _vm.properties.invoice
                                                            .telephone
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "125",
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .telephone,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "telephone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.telephone"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("el-col", {
                                        staticClass: "vietnam-top-border-w1",
                                        attrs: { span: 6 }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "vietnam-top-border-w1",
                                          staticStyle: { padding: "5px 5px" },
                                          attrs: { span: 18 }
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { gutter: 10 }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label:
                                                      "Họ tên người mua hàng (Buyer):",
                                                    "label-width": "200px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "126",
                                                          readonly: ""
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label:
                                                      "Tên đơnvị (Company's name):",
                                                    "label-width": "200px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c(
                                                        "cargo-advance-select",
                                                        {
                                                          attrs: {
                                                            no: "127",
                                                            "select-type":
                                                              _vm
                                                                .selectTypeNames
                                                                .static_data_Title,
                                                            "allow-create": true,
                                                            filterable: "",
                                                            cache: false,
                                                            disabled:
                                                              _vm.locked,
                                                            "default-value":
                                                              _vm.properties
                                                                .invoice.title,
                                                            "static-options":
                                                              _vm.titleArray
                                                          },
                                                          on: {
                                                            parentCallBack:
                                                              _vm.titleChangeEvent
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label:
                                                      "Mã số thuế (Tax code):",
                                                    "label-width": "200px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "128",
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .buyerTaxAccount,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "buyerTaxAccount",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.buyerTaxAccount"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: "Địa chỉ (Address):",
                                                    "label-width": "200px"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 18,
                                                        title:
                                                          _vm.properties.invoice
                                                            .buyerAddress
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "129",
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .buyerAddress,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "buyerAddress",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.buyerAddress"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 6,
                                                        title:
                                                          _vm.properties.invoice
                                                            .buyerTelephone
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          no: "130",
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .buyerTelephone,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "buyerTelephone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.buyerTelephone"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c("el-col", {
                                        staticClass: "vietnam-top-border-w1",
                                        attrs: { span: 6 }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "vietnam-top-border-w1",
                                          staticStyle: {
                                            "flex-direction": "row",
                                            "justify-content": "flex-start",
                                            padding: "5px 5px"
                                          },
                                          attrs: { span: 24 }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  "Hình thứcthanh toán (Payment method):",
                                                "label-width": "230px"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "175px"
                                                  },
                                                  attrs: {
                                                    no: "131",
                                                    disabled: _vm.locked
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.properties.invoice
                                                        .paymentMethod,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.properties.invoice,
                                                        "paymentMethod",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "properties.invoice.paymentMethod"
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.InvoiceConstant
                                                    .PAYMENT_METHOD_VIETNAM,
                                                  function(item) {
                                                    return _c("el-option", {
                                                      key: item.code,
                                                      attrs: {
                                                        label: item.englishName,
                                                        value: item.code
                                                      }
                                                    })
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "bank-mode",
                                              attrs: { "label-width": "180px" }
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  attrs: {
                                                    slot: "label",
                                                    no: "132",
                                                    disabled: true
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.buyerBankModeChange
                                                  },
                                                  slot: "label",
                                                  model: {
                                                    value:
                                                      _vm.properties.invoice
                                                        .buyerBankMode,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.properties.invoice,
                                                        "buyerBankMode",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "properties.invoice.buyerBankMode"
                                                  }
                                                },
                                                [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label:
                                                        "Số tài khoản (A/C number):",
                                                      value: 0
                                                    }
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "CargoMsg.Cargo_DepositBankAndAccountNo"
                                                      ),
                                                      value: 1
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                {
                                                  attrs: {
                                                    span: 12,
                                                    title:
                                                      _vm.properties.invoice
                                                        .buyerBank
                                                  }
                                                },
                                                [
                                                  _c("cargo-advance-select", {
                                                    attrs: {
                                                      no: "133",
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .static_data_TitleBank,
                                                      "allow-create": true,
                                                      filterable: "",
                                                      cache: false,
                                                      disabled: _vm.locked,
                                                      "tag-value": "uuid",
                                                      "default-value":
                                                        _vm.buyerBankUuid,
                                                      "static-options":
                                                        _vm.titleBankArray
                                                    },
                                                    on: {
                                                      parentCallBack:
                                                        _vm.getBankCusFromChild
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                {
                                                  attrs: {
                                                    span: 10,
                                                    title:
                                                      _vm.properties.invoice
                                                        .buyerBankAccount
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      no: "134",
                                                      disabled: _vm.locked
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .buyerBankAccount,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "buyerBankAccount",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.buyerBankAccount"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: {
                                            "flex-direction": "row",
                                            "justify-content": "flex-start",
                                            padding: "5px 5px"
                                          },
                                          attrs: { span: 24 }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Remark:",
                                                "label-width": "100px"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "783px"
                                                    },
                                                    attrs: {
                                                      no: "remark",
                                                      disabled: _vm.locked
                                                    },
                                                    on: {
                                                      input:
                                                        _vm.markInvoiceRemarkModified
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .remark,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "remark",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.remark"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  !_vm.locked
                                    ? _c(
                                        "el-row",
                                        {
                                          staticClass: "vatInvoiceForm-section",
                                          attrs: { type: "flex" }
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass:
                                                "vietnam-both-top-border-w1",
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "flex-end"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      attrs: { no: "135" },
                                                      on: {
                                                        change:
                                                          _vm.rbgShowChargeDetailChangeHandler
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.properties
                                                            .rbgShowChargeDetail,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.properties,
                                                            "rbgShowChargeDetail",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "properties.rbgShowChargeDetail"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px"
                                                          },
                                                          attrs: {
                                                            label: "merge"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Details of Combination"
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px"
                                                          },
                                                          attrs: {
                                                            label: "detail",
                                                            disabled:
                                                              !_vm.properties
                                                                .showChargeDetailByInvoice ||
                                                              _vm.approvalLocked
                                                          }
                                                        },
                                                        [_vm._v("Show details")]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-button-group",
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: { no: "136" },
                                                          on: {
                                                            click:
                                                              _vm.addInvoiceItemHandler
                                                          }
                                                        },
                                                        [_vm._v("Add")]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: { no: "137" },
                                                          on: {
                                                            click:
                                                              _vm.removeInvoiceItemHandler
                                                          }
                                                        },
                                                        [_vm._v("Delete")]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name:
                                                                "permission",
                                                              rawName:
                                                                "v-permission",
                                                              value: [
                                                                "button_ACInvoice_saveInvoiceAmount"
                                                              ],
                                                              expression:
                                                                "['button_ACInvoice_saveInvoiceAmount']"
                                                            }
                                                          ],
                                                          attrs: { no: "138" },
                                                          on: {
                                                            click:
                                                              _vm.checkInvoiceNoSaveAndCalcAmountHandler
                                                          }
                                                        },
                                                        [_vm._v("Update")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass:
                                            "vietnam-both-top-border-w1"
                                        },
                                        [
                                          _c("cargo-ag-grid", {
                                            staticStyle: {
                                              height: "123px",
                                              width: "100%"
                                            },
                                            attrs: {
                                              "show-side-bar": false,
                                              "grid-params":
                                                _vm.vatInvoiceGrid.gridParams,
                                              "grid-options":
                                                _vm.vatInvoiceGrid.gridOptions,
                                              "column-defs":
                                                _vm.vatInvoiceGridColumnDefsVietnam,
                                              "row-data":
                                                _vm.vatInvoiceGridRowData,
                                              "auto-fit-content": false
                                            },
                                            on: {
                                              "update:gridParams": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.vatInvoiceGrid,
                                                  "gridParams",
                                                  $event
                                                )
                                              },
                                              "update:grid-params": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.vatInvoiceGrid,
                                                  "gridParams",
                                                  $event
                                                )
                                              },
                                              gridReady: function(params) {
                                                return (_vm.gridApi =
                                                  params.api)
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass:
                                            "vietnam-left-top-border-w1",
                                          staticStyle: {
                                            "flex-direction": "row",
                                            "justify-content": "flex-start",
                                            padding: "5px 5px"
                                          },
                                          attrs: { span: 18 }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "Ty giá(Exchange rate):",
                                                "label-width": "200px"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      no: "139",
                                                      disabled: true
                                                    },
                                                    model: {
                                                      value: _vm.rateVietnam,
                                                      callback: function($$v) {
                                                        _vm.rateVietnam = $$v
                                                      },
                                                      expression: "rateVietnam"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c("el-form-item", {
                                            staticStyle: {
                                              "padding-left": "120px"
                                            },
                                            attrs: {
                                              label:
                                                "Cộng tiên hàng (Sub total):",
                                              "label-width": "200px"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass:
                                            "vietnam-both-top-border-w1",
                                          attrs: { span: 6 }
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "140px" },
                                            attrs: {
                                              no: "140",
                                              disabled: true
                                            },
                                            model: {
                                              value:
                                                _vm.excludingTaxAmountVietnam,
                                              callback: function($$v) {
                                                _vm.excludingTaxAmountVietnam = $$v
                                              },
                                              expression:
                                                "excludingTaxAmountVietnam"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass:
                                            "vietnam-left-top-border-w1",
                                          staticStyle: {
                                            "flex-direction": "row",
                                            "justify-content": "flex-start",
                                            padding: "5px 5px"
                                          },
                                          attrs: { span: 18 }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  "Thué suãt GTGT(VAT rate):",
                                                "label-width": "200px"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-col",
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      no: "141",
                                                      disabled: true
                                                    },
                                                    model: {
                                                      value: _vm.taxRateVietnam,
                                                      callback: function($$v) {
                                                        _vm.taxRateVietnam = $$v
                                                      },
                                                      expression:
                                                        "taxRateVietnam"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c("el-form-item", {
                                            staticStyle: {
                                              "padding-left": "120px"
                                            },
                                            attrs: {
                                              label:
                                                "Tiên thué GTGT(VAT amount):",
                                              "label-width": "200px"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass:
                                            "vietnam-both-top-border-w1",
                                          attrs: { span: 6 }
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "140px" },
                                            attrs: {
                                              no: "142",
                                              disabled: true
                                            },
                                            model: {
                                              value: _vm.taxAmountVietnam,
                                              callback: function($$v) {
                                                _vm.taxAmountVietnam = $$v
                                              },
                                              expression: "taxAmountVietnam"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass:
                                            "vietnam-left-top-border-w1",
                                          staticStyle: {
                                            "flex-direction": "row",
                                            "justify-content": "flex-start",
                                            padding: "5px 5px"
                                          },
                                          attrs: { span: 18 }
                                        },
                                        [
                                          _c("el-form-item", {
                                            staticStyle: {
                                              "padding-left": "315px"
                                            },
                                            attrs: {
                                              label:
                                                "Töng công tien thanh toan (Total payment):",
                                              "label-width": "360px"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass:
                                            "vietnam-both-top-border-w1",
                                          attrs: { span: 6 }
                                        },
                                        [
                                          _c("el-input", {
                                            staticStyle: { width: "140px" },
                                            attrs: {
                                              no: "143",
                                              disabled: true
                                            },
                                            model: {
                                              value: _vm.amountVietnam,
                                              callback: function($$v) {
                                                _vm.amountVietnam = $$v
                                              },
                                              expression: "amountVietnam"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass:
                                            "vietnam-both-top-border-w1",
                                          staticStyle: {
                                            "flex-direction": "row",
                                            "justify-content": "flex-start",
                                            padding: "5px 5px"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  "Số tiền viết bằng chữ (Amount in words):",
                                                "label-width": "250px"
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                staticStyle: { width: "620px" },
                                                attrs: {
                                                  no: "144",
                                                  disabled:
                                                    _vm.chineseAmountDisabledVietnam
                                                },
                                                model: {
                                                  value:
                                                    _vm.properties.invoice
                                                      .chineseAmount,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.properties.invoice,
                                                      "chineseAmount",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "properties.invoice.chineseAmount"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "vietnam-top-border-w1",
                                          staticStyle: {
                                            "flex-direction": "row",
                                            "justify-content": "flex-start",
                                            "padding-top": "5px"
                                          }
                                        },
                                        [
                                          false
                                            ? _c("el-form-item", {
                                                attrs: {
                                                  label:
                                                    "Người mua hàng (Buyer):",
                                                  "label-width": "200px"
                                                }
                                              })
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.properties.invoice.ar &&
                      [6, 7].includes(_vm.properties.invoice.invoiceType)
                        ? _c(
                            "div",
                            { attrs: { id: "invoiceFei" } },
                            [
                              _c(
                                "el-form",
                                {
                                  staticClass: "vatInvoiceForm",
                                  attrs: {
                                    "label-width": "100px",
                                    "label-position": "right"
                                  }
                                },
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-header",
                                      attrs: { type: "flex", gutter: 10 }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "left",
                                          attrs: { span: 7 }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t(
                                                    "Invoice.invoice_makeType"
                                                  ) + "："
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.makeType))
                                              ]),
                                              _vm.properties.invoice
                                                .invoiceState === 1 ||
                                              _vm.properties.invoice
                                                .invoiceState === 2
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "5px",
                                                        color: "red",
                                                        "font-size": "16px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.redPunch)
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label:
                                                  _vm.$t(
                                                    "Invoice.invoice_invoiceStatus"
                                                  ) + "："
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.isPrinted))
                                              ]),
                                              _vm.properties.invoice
                                                .makeType === 0 &&
                                              _vm.properties.invoice
                                                .invoiceType ===
                                                _vm.InvoiceConstant
                                                  .INVOICE_TYPE_VAT_FEI.code &&
                                              _vm.properties.invoice
                                                .invoiceState === 2
                                                ? _c("el-input", {
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "CargoMsg.Cargo_PleaseEnterScarletLetterNumber"
                                                      ),
                                                      max: "20",
                                                      disabled:
                                                        !_vm.enabledCnnoticeNo ||
                                                        _vm.approvalLocked
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .cnnoticeNo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "cnnoticeNo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.cnnoticeNo"
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "center",
                                          attrs: { span: 10 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticStyle: { width: "100%" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-size": "22px",
                                                    color: "red",
                                                    display: "block",
                                                    "text-align": "center"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.lbInvoiceType)
                                                  )
                                                ]
                                              ),
                                              _c("div", {
                                                staticStyle: {
                                                  "padding-top": "6px",
                                                  width: "100%",
                                                  "border-bottom":
                                                    "1px solid red"
                                                }
                                              }),
                                              _c("div", {
                                                staticStyle: {
                                                  "padding-top": "3px",
                                                  width: "100%",
                                                  "border-bottom":
                                                    "1px solid red"
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "right",
                                          attrs: { span: 7 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_InvoiceNo"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled:
                                                        !_vm.properties
                                                          .invoiceNoEditable ||
                                                        _vm.invoiceReadonly ||
                                                        _vm.approvalLocked
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .invoiceNo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "invoiceNo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.invoiceNo"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_InvoiceDate"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-date-picker", {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      type: "date",
                                                      clearable: false,
                                                      disabled: _vm.locked
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.invoiceDateChange
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .invoiceDate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "invoiceDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.invoiceDate"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          attrs: { span: 1 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title-vertical" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Invoice.PurchaserInformation"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          staticStyle: { padding: "5px 5px" },
                                          attrs: { span: 11 }
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { gutter: 10 }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Name"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c(
                                                        "cargo-advance-select",
                                                        {
                                                          attrs: {
                                                            "select-type":
                                                              _vm
                                                                .selectTypeNames
                                                                .static_data_Title,
                                                            "allow-create":
                                                              !_vm.arSettlementUnitOptional ||
                                                              !_vm.properties
                                                                .invoice.ar,
                                                            filterable: "",
                                                            cache: false,
                                                            disabled:
                                                              _vm.locked,
                                                            "default-value":
                                                              _vm.properties
                                                                .invoice.title,
                                                            "static-options":
                                                              _vm.titleArray
                                                          },
                                                          on: {
                                                            parentCallBack:
                                                              _vm.titleChangeEvent
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_RegistrationNumber"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .buyerTaxAccount,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "buyerTaxAccount",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.buyerTaxAccount"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_AddressTelNo"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 12,
                                                        title:
                                                          _vm.properties.invoice
                                                            .buyerAddress
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .buyerAddress,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "buyerAddress",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.buyerAddress"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 12,
                                                        title:
                                                          _vm.properties.invoice
                                                            .buyerTelephone
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .buyerTelephone,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "buyerTelephone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.buyerTelephone"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm.bankModeAvailable
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticClass: "bank-mode"
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            slot: "label",
                                                            disabled: _vm.locked
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.buyerBankModeChange
                                                          },
                                                          slot: "label",
                                                          model: {
                                                            value:
                                                              _vm.properties
                                                                .invoice
                                                                .buyerBankMode,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.properties
                                                                  .invoice,
                                                                "buyerBankMode",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "properties.invoice.buyerBankMode"
                                                          }
                                                        },
                                                        [
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "CargoMsg.Cargo_BankAccountNo"
                                                              ),
                                                              value: 0
                                                            }
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "CargoMsg.Cargo_DepositBankAndAccountNo"
                                                              ),
                                                              value: 1
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm.properties.invoice
                                                        .buyerBankMode === 1
                                                        ? _c(
                                                            "el-col",
                                                            {
                                                              attrs: {
                                                                span: 24,
                                                                title:
                                                                  _vm.properties
                                                                    .invoice
                                                                    .buyerDepositBankAccount
                                                              }
                                                            },
                                                            [
                                                              _c("el-input", {
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.locked
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .properties
                                                                      .invoice
                                                                      .buyerDepositBankAccount,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .properties
                                                                        .invoice,
                                                                      "buyerDepositBankAccount",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "properties.invoice.buyerDepositBankAccount"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        : [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 12,
                                                                  title:
                                                                    _vm
                                                                      .properties
                                                                      .invoice
                                                                      .buyerBank
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "cargo-advance-select",
                                                                  {
                                                                    attrs: {
                                                                      "select-type":
                                                                        _vm
                                                                          .selectTypeNames
                                                                          .static_data_TitleBank,
                                                                      "allow-create": true,
                                                                      filterable:
                                                                        "",
                                                                      cache: false,
                                                                      disabled:
                                                                        _vm.locked,
                                                                      "tag-value":
                                                                        "uuid",
                                                                      "default-value":
                                                                        _vm.buyerBankUuid,
                                                                      "static-options":
                                                                        _vm.titleBankArray
                                                                    },
                                                                    on: {
                                                                      parentCallBack:
                                                                        _vm.getBankCusFromChild
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 12,
                                                                  title:
                                                                    _vm
                                                                      .properties
                                                                      .invoice
                                                                      .buyerBankAccount
                                                                }
                                                              },
                                                              [
                                                                _c("el-input", {
                                                                  attrs: {
                                                                    disabled:
                                                                      _vm.locked
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .properties
                                                                        .invoice
                                                                        .buyerBankAccount,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .properties
                                                                          .invoice,
                                                                        "buyerBankAccount",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "properties.invoice.buyerBankAccount"
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              !_vm.bankModeAvailable
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "CargoMsg.Cargo_BankAccountNo"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-col",
                                                        {
                                                          attrs: {
                                                            span: 12,
                                                            title:
                                                              _vm.properties
                                                                .invoice
                                                                .buyerBank
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "cargo-advance-select",
                                                            {
                                                              attrs: {
                                                                "select-type":
                                                                  _vm
                                                                    .selectTypeNames
                                                                    .static_data_TitleBank,
                                                                "allow-create": true,
                                                                filterable: "",
                                                                cache: false,
                                                                disabled:
                                                                  _vm.locked,
                                                                "tag-value":
                                                                  "uuid",
                                                                "default-value":
                                                                  _vm.buyerBankUuid,
                                                                "static-options":
                                                                  _vm.titleBankArray
                                                              },
                                                              on: {
                                                                parentCallBack:
                                                                  _vm.getBankCusFromChild
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-col",
                                                        {
                                                          attrs: {
                                                            span: 12,
                                                            title:
                                                              _vm.properties
                                                                .invoice
                                                                .buyerBankAccount
                                                          }
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled:
                                                                _vm.locked
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.properties
                                                                  .invoice
                                                                  .buyerBankAccount,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.properties
                                                                    .invoice,
                                                                  "buyerBankAccount",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "properties.invoice.buyerBankAccount"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "4px"
                                                      },
                                                      attrs: {
                                                        disabled:
                                                          _vm.locked ||
                                                          _vm.isDisplayDisabled
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.properties.invoice
                                                            .displayBuyer,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.properties
                                                              .invoice,
                                                            "displayBuyer",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "properties.invoice.displayBuyer"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_DisplayBuyer"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          attrs: { span: 1 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title-vertical" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "Invoice.SellerInformation"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          staticStyle: { padding: "5px 5px" },
                                          attrs: { span: 11 }
                                        },
                                        [
                                          _c(
                                            "el-row",
                                            {
                                              staticStyle: { width: "100%" },
                                              attrs: { gutter: 10 }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_Name"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c(
                                                        "cargo-advance-select",
                                                        {
                                                          attrs: {
                                                            "select-type":
                                                              _vm
                                                                .selectTypeNames
                                                                .static_data_InvoiceTitle,
                                                            "allow-create": true,
                                                            filterable: "",
                                                            cache: false,
                                                            disabled:
                                                              _vm.locked ||
                                                              _vm.ourInvoiceTitleLocked,
                                                            "default-value":
                                                              _vm.properties
                                                                .invoice
                                                                .sellTitle,
                                                            "static-options":
                                                              _vm.ourInvoiceTitleArray
                                                          },
                                                          on: {
                                                            parentCallBack:
                                                              _vm.ourTitleChangeEvent
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_RegistrationNumber"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.locked ||
                                                            _vm.ourInvoiceTitleLocked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .taxAccount,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "taxAccount",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.taxAccount"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_AddressTelNo"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 12,
                                                        title:
                                                          _vm.properties.invoice
                                                            .address
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice.address,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "address",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.address"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-col",
                                                    {
                                                      attrs: {
                                                        span: 12,
                                                        title:
                                                          _vm.properties.invoice
                                                            .telephone
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        attrs: {
                                                          disabled: _vm.locked
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice
                                                              .telephone,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "telephone",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.telephone"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _vm.bankModeAvailable
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      staticClass: "bank-mode"
                                                    },
                                                    [
                                                      _c(
                                                        "el-select",
                                                        {
                                                          attrs: {
                                                            slot: "label",
                                                            disabled: _vm.locked
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.sellerBankModeChange
                                                          },
                                                          slot: "label",
                                                          model: {
                                                            value:
                                                              _vm.properties
                                                                .invoice
                                                                .sellerBankMode,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.properties
                                                                  .invoice,
                                                                "sellerBankMode",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "properties.invoice.sellerBankMode"
                                                          }
                                                        },
                                                        [
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "CargoMsg.Cargo_BankAccountNo"
                                                              ),
                                                              value: 0
                                                            }
                                                          }),
                                                          _c("el-option", {
                                                            attrs: {
                                                              label: _vm.$t(
                                                                "CargoMsg.Cargo_DepositBankAndAccountNo"
                                                              ),
                                                              value: 1
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                      _vm.properties.invoice
                                                        .sellerBankMode === 1
                                                        ? _c(
                                                            "el-col",
                                                            {
                                                              attrs: {
                                                                span: 24,
                                                                title:
                                                                  _vm.properties
                                                                    .invoice
                                                                    .sellerDepositBankAccount
                                                              }
                                                            },
                                                            [
                                                              _c("el-input", {
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.locked
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm
                                                                      .properties
                                                                      .invoice
                                                                      .sellerDepositBankAccount,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .properties
                                                                        .invoice,
                                                                      "sellerDepositBankAccount",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "properties.invoice.sellerDepositBankAccount"
                                                                }
                                                              })
                                                            ],
                                                            1
                                                          )
                                                        : [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 12,
                                                                  title: _vm.getOurBankName()
                                                                }
                                                              },
                                                              [
                                                                _c(
                                                                  "cargo-advance-select",
                                                                  {
                                                                    attrs: {
                                                                      filterable:
                                                                        "",
                                                                      "select-type":
                                                                        _vm
                                                                          .selectTypeNames
                                                                          .static_data_BankAccount,
                                                                      cache: false,
                                                                      "method-params": {
                                                                        officeUuid:
                                                                          _vm
                                                                            .$store
                                                                            .getters
                                                                            .currentOfficeUuid
                                                                      },
                                                                      "default-value":
                                                                        _vm.ourBankAccountId ||
                                                                        "",
                                                                      "static-options":
                                                                        _vm.ourBankAccountArray,
                                                                      disabled:
                                                                        _vm.locked ||
                                                                        _vm.ourBankAccountAutoLocked,
                                                                      "options-width":
                                                                        "450px"
                                                                    },
                                                                    on: {
                                                                      parentCallBack:
                                                                        _vm.getBankAccountFromChild
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 12,
                                                                  title:
                                                                    _vm
                                                                      .properties
                                                                      .invoice
                                                                      .bankAccount
                                                                }
                                                              },
                                                              [
                                                                _c("el-input", {
                                                                  attrs: {
                                                                    disabled: true
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm
                                                                        .properties
                                                                        .invoice
                                                                        .bankAccount,
                                                                    callback: function(
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm
                                                                          .properties
                                                                          .invoice,
                                                                        "bankAccount",
                                                                        $$v
                                                                      )
                                                                    },
                                                                    expression:
                                                                      "properties.invoice.bankAccount"
                                                                  }
                                                                })
                                                              ],
                                                              1
                                                            )
                                                          ]
                                                    ],
                                                    2
                                                  )
                                                : _vm._e(),
                                              !_vm.bankModeAvailable
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "CargoMsg.Cargo_BankAccountNo"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-col",
                                                        {
                                                          attrs: {
                                                            span: 12,
                                                            title: _vm.getOurBankName()
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "cargo-advance-select",
                                                            {
                                                              attrs: {
                                                                filterable: "",
                                                                "select-type":
                                                                  _vm
                                                                    .selectTypeNames
                                                                    .static_data_BankAccount,
                                                                cache: false,
                                                                "method-params": {
                                                                  officeUuid:
                                                                    _vm.$store
                                                                      .getters
                                                                      .currentOfficeUuid
                                                                },
                                                                "default-value":
                                                                  _vm.ourBankAccountId ||
                                                                  "",
                                                                "static-options":
                                                                  _vm.ourBankAccountArray,
                                                                disabled:
                                                                  _vm.locked ||
                                                                  _vm.ourBankAccountAutoLocked,
                                                                "options-width":
                                                                  "450px"
                                                              },
                                                              on: {
                                                                parentCallBack:
                                                                  _vm.getBankAccountFromChild
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-col",
                                                        {
                                                          attrs: {
                                                            span: 12,
                                                            title:
                                                              _vm.properties
                                                                .invoice
                                                                .bankAccount
                                                          }
                                                        },
                                                        [
                                                          _c("el-input", {
                                                            attrs: {
                                                              disabled: true
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.properties
                                                                  .invoice
                                                                  .bankAccount,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  _vm.properties
                                                                    .invoice,
                                                                  "bankAccount",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "properties.invoice.bankAccount"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "4px"
                                                      },
                                                      attrs: {
                                                        disabled:
                                                          _vm.locked ||
                                                          _vm.isDisplayDisabled
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.properties.invoice
                                                            .displaySell,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.properties
                                                              .invoice,
                                                            "displaySell",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "properties.invoice.displaySell"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "CargoMsg.Cargo_DisplaySell"
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  !_vm.locked
                                    ? _c(
                                        "el-row",
                                        {
                                          staticClass: "vatInvoiceForm-section",
                                          attrs: { type: "flex" }
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass:
                                                "red-both-top-border-w1",
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "flex-end"
                                              }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                [
                                                  _c(
                                                    "el-radio-group",
                                                    {
                                                      attrs: {
                                                        disabled: _vm.lookView
                                                      },
                                                      on: {
                                                        change:
                                                          _vm.rbgShowChargeDetailChangeHandler
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.properties
                                                            .rbgShowChargeDetail,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.properties,
                                                            "rbgShowChargeDetail",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "properties.rbgShowChargeDetail"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px"
                                                          },
                                                          attrs: {
                                                            label: "merge"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_Sp18"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-radio",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px"
                                                          },
                                                          attrs: {
                                                            label: "detail",
                                                            disabled:
                                                              !_vm.properties
                                                                .showChargeDetailByInvoice ||
                                                              _vm.approvalLocked
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_ShowDetails"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "el-button-group",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value: !_vm.lookView,
                                                          expression:
                                                            "!lookView"
                                                        }
                                                      ]
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          on: {
                                                            click:
                                                              _vm.addInvoiceItemHandler
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_Add"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          on: {
                                                            click:
                                                              _vm.removeInvoiceItemHandler
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_Delete"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name:
                                                                "permission",
                                                              rawName:
                                                                "v-permission",
                                                              value: [
                                                                "button_ACInvoice_saveInvoiceAmount"
                                                              ],
                                                              expression:
                                                                "['button_ACInvoice_saveInvoiceAmount']"
                                                            }
                                                          ],
                                                          on: {
                                                            click:
                                                              _vm.checkInvoiceNoSaveAndCalcAmountHandler
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_Reflush"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-both-top-border-w1"
                                        },
                                        [
                                          _c("cargo-ag-grid", {
                                            staticStyle: {
                                              height: "123px",
                                              width: "100%"
                                            },
                                            attrs: {
                                              "show-side-bar": false,
                                              "grid-params":
                                                _vm.vatInvoiceGrid.gridParams,
                                              "grid-options":
                                                _vm.vatInvoiceGrid.gridOptions,
                                              "column-defs":
                                                _vm.vatInvoiceGridColumnDefs,
                                              "row-data":
                                                _vm.vatInvoiceGridRowData,
                                              "auto-fit-content": false
                                            },
                                            on: {
                                              "update:gridParams": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.vatInvoiceGrid,
                                                  "gridParams",
                                                  $event
                                                )
                                              },
                                              "update:grid-params": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.vatInvoiceGrid,
                                                  "gridParams",
                                                  $event
                                                )
                                              },
                                              gridReady: function(params) {
                                                return (_vm.gridApi =
                                                  params.api)
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.properties.invoice
                                    .specificConstraintType ===
                                  _vm.InvoiceConstant
                                    .SPECIFIC_CONSTRAINT_TYPE_CTS.code
                                    ? _c(
                                        "el-row",
                                        {
                                          staticClass: "vatInvoiceForm-section",
                                          attrs: { type: "flex" }
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass:
                                                "red-both-top-border-w1"
                                            },
                                            [
                                              _c("cargo-ag-grid", {
                                                staticStyle: {
                                                  height: "123px",
                                                  width: "100%"
                                                },
                                                attrs: {
                                                  "show-side-bar": false,
                                                  "grid-params":
                                                    _vm.cargoTransportGrid
                                                      .gridParams,
                                                  "grid-options":
                                                    _vm.cargoTransportGrid
                                                      .gridOptions,
                                                  "column-defs":
                                                    _vm.cargoTransportGridColumnDefs,
                                                  "row-data":
                                                    _vm.cargoTransportGridRowData,
                                                  "auto-fit-content": false
                                                },
                                                on: {
                                                  "update:gridParams": function(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.cargoTransportGrid,
                                                      "gridParams",
                                                      $event
                                                    )
                                                  },
                                                  "update:grid-params": function(
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      _vm.cargoTransportGrid,
                                                      "gridParams",
                                                      $event
                                                    )
                                                  },
                                                  gridReady: function(params) {
                                                    return (_vm.cargoTransportGrid.gridApi =
                                                      params.api)
                                                  }
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          attrs: { span: 4 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title-horizontal" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_TotalPriceWithTaxInWords"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-both-top-border-w1",
                                          attrs: { span: 20 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" }
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    padding: "0 10px"
                                                  },
                                                  attrs: {
                                                    label: "",
                                                    "label-width": "0"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "286px"
                                                    },
                                                    attrs: { disabled: true },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .chineseAmount,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "chineseAmount",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.chineseAmount"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticStyle: {
                                                    display: "flex"
                                                  },
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_LowerCase"
                                                    ),
                                                    "label-width": "50"
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "140px"
                                                    },
                                                    attrs: { disabled: true },
                                                    model: {
                                                      value: _vm.amount,
                                                      callback: function($$v) {
                                                        _vm.amount = $$v
                                                      },
                                                      expression: "amount"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          attrs: { span: 1 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title-vertical" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Remarks"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          staticStyle: { padding: "5px 5px" },
                                          attrs: { span: 11 }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass:
                                                "el-form-item-textarea-w-full",
                                              attrs: { "label-width": "0" }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  type: "textarea",
                                                  disabled: _vm.locked
                                                },
                                                on: {
                                                  input:
                                                    _vm.markInvoiceRemarkModified
                                                },
                                                model: {
                                                  value:
                                                    _vm.properties.invoice
                                                      .remark,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.properties.invoice,
                                                      "remark",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "properties.invoice.remark"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-left-top-border-w1",
                                          attrs: { span: 1 }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "title-vertical" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_FinancialRemarks"
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-both-top-border-w1",
                                          attrs: { span: 11 }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass:
                                                "el-form-item-textarea-w-full",
                                              attrs: { "label-width": "0" }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: {
                                                  type: "textarea",
                                                  disabled: _vm.locked
                                                },
                                                model: {
                                                  value:
                                                    _vm.properties.invoice
                                                      .remark2,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.properties.invoice,
                                                      "remark2",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "properties.invoice.remark2"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    {
                                      staticClass: "vatInvoiceForm-section",
                                      attrs: { type: "flex" }
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "red-top-border-w1",
                                          staticStyle: {
                                            "flex-direction": "row",
                                            "justify-content": "flex-start",
                                            "padding-top": "5px"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "el-form-item-w240",
                                              attrs: {
                                                label: _vm.$t(
                                                  "CargoMsg.Cargo_Payee"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: { disabled: _vm.locked },
                                                model: {
                                                  value:
                                                    _vm.properties.invoice
                                                      .payee,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.properties.invoice,
                                                      "payee",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "properties.invoice.payee"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "el-form-item-w240",
                                              attrs: {
                                                label: _vm.$t(
                                                  "CargoMsg.Cargo_Recheck"
                                                )
                                              }
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: { disabled: _vm.locked },
                                                model: {
                                                  value:
                                                    _vm.properties.invoice
                                                      .auditor,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.properties.invoice,
                                                      "auditor",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "properties.invoice.auditor"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              staticClass: "el-form-item-w240",
                                              attrs: {
                                                label: _vm.$t(
                                                  "CargoMsg.Cargo_InvoicedBy"
                                                )
                                              }
                                            },
                                            [
                                              !_vm.openInvoicerConfig
                                                ? _c("el-input", {
                                                    attrs: {
                                                      no: "inputBy1",
                                                      disabled: true
                                                    },
                                                    model: {
                                                      value: _vm.inputBy,
                                                      callback: function($$v) {
                                                        _vm.inputBy = $$v
                                                      },
                                                      expression: "inputBy"
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm.openInvoicerConfig
                                                ? _c("cargo-advance-select", {
                                                    attrs: {
                                                      no: "inputBy",
                                                      filterable: "",
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .static_data_User,
                                                      "default-value":
                                                        _vm.properties.invoice
                                                          .inputBy || "",
                                                      disabled: _vm.locked,
                                                      cache: false,
                                                      "tag-value": "userId",
                                                      "static-options":
                                                        _vm.invoicerUsersList
                                                    },
                                                    on: {
                                                      parentCallBack: function(
                                                        p
                                                      ) {
                                                        _vm.properties.invoice.inputBy =
                                                          p.value
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.properties.invoice.ar
                        ? _c(
                            "div",
                            {
                              staticStyle: { padding: "10px 20px" },
                              attrs: { id: "invoicePayBoard" }
                            },
                            [
                              _c(
                                "el-form",
                                {
                                  attrs: {
                                    inline: true,
                                    "label-width": _vm.$selectByLang(
                                      "90px",
                                      "100px"
                                    ),
                                    "label-position": "left"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "flex-direction": "row"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { flex: "1" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  class: _vm.$selectByLang(
                                                    "el-form-item-label90-w220",
                                                    "el-form-item-label100-w230"
                                                  ),
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.invoice_invoiceNo"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      no: "95",
                                                      disabled:
                                                        _vm.invoiceReadonly
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .invoiceNo,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "invoiceNo",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.invoiceNo"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticClass:
                                                    "el-form-item-date-w130",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.invoice_invoicingDate"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-date-picker", {
                                                    attrs: {
                                                      no: "96",
                                                      type: "date",
                                                      clearable: false,
                                                      disabled: _vm.locked
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.invoiceDateChange
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .invoiceDate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "invoiceDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.invoiceDate"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  class: _vm.$selectByLang(
                                                    "el-form-item-label90-w280",
                                                    "el-form-item-label100-w290"
                                                  ),
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.invoice_invoiceHeader"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("cargo-advance-select", {
                                                    attrs: {
                                                      no: "97",
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .static_data_Title,
                                                      "allow-create": true,
                                                      filterable: "",
                                                      cache: false,
                                                      disabled:
                                                        _vm.invoiceReadonly,
                                                      "default-value":
                                                        _vm.properties.invoice
                                                          .title,
                                                      "static-options":
                                                        _vm.customerTitles
                                                    },
                                                    on: {
                                                      parentCallBack:
                                                        _vm.apTitleChangeEvent
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  class: _vm.$selectByLang(
                                                    "el-form-item-label90-w280",
                                                    "el-form-item-label100-w290"
                                                  ),
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_ReceiptInvoiceTitle"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("cargo-advance-select", {
                                                    attrs: {
                                                      no: "receiptInvoiceTitle",
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .static_data_InvoiceTitle,
                                                      "allow-create": true,
                                                      filterable: "",
                                                      cache: false,
                                                      disabled:
                                                        _vm.invoiceReadonly,
                                                      "default-value":
                                                        _vm.properties.invoice
                                                          .receiptInvoiceTitle,
                                                      "static-options":
                                                        _vm.ourInvoiceTitleArray
                                                    },
                                                    on: {
                                                      parentCallBack:
                                                        _vm.apReceiptInvoiceTitleChangeEvent
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  class: _vm.$selectByLang(
                                                    "el-form-item-label90-w220",
                                                    "el-form-item-label100-w230"
                                                  ),
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.invoice_exchangeRate"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      no: "98"
                                                    },
                                                    model: {
                                                      value: _vm.rate,
                                                      callback: function($$v) {
                                                        _vm.rate = $$v
                                                      },
                                                      expression: "rate"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  class: _vm.$selectByLang(
                                                    "el-form-item-label90-w220",
                                                    "el-form-item-label100-w230"
                                                  ),
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.invoice_totalAmount"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      no: "99"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .chineseAmount,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "chineseAmount",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.chineseAmount"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.invoice_total"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input-number", {
                                                        attrs: {
                                                          disabled:
                                                            _vm.invoiceReadonly,
                                                          no: "100",
                                                          precision: 2,
                                                          step: 1,
                                                          min: -999999999999,
                                                          max: 999999999999,
                                                          "controls-position":
                                                            "right"
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.amountChangeHandler
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.properties
                                                              .invoice.amount,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.properties
                                                                .invoice,
                                                              "amount",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "properties.invoice.amount"
                                                        }
                                                      }),
                                                      _c(
                                                        "el-button",
                                                        {
                                                          directives: [
                                                            {
                                                              name:
                                                                "permission",
                                                              rawName:
                                                                "v-permission",
                                                              value: [
                                                                "button_ACInvoice_saveInvoiceAmount"
                                                              ],
                                                              expression:
                                                                "['button_ACInvoice_saveInvoiceAmount']"
                                                            }
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.invoiceReadonly
                                                          },
                                                          on: {
                                                            click:
                                                              _vm.checkInvoiceNoSaveAndCalcAmountHandlerPayable
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "CargoMsg.Cargo_Reflush"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.invoice_taxFreeAmount"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input-number", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.invoiceReadonly,
                                                      no: "101",
                                                      precision: 2,
                                                      step: 1,
                                                      min: -999999999999,
                                                      max: 999999999999,
                                                      "controls-position":
                                                        "right"
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.taxFreeAmountChangeHandler
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .excludingTaxAmount,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "excludingTaxAmount",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.excludingTaxAmount"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm.eiTaxControlInterfaceName ===
                                          "NUONUO"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "el-form-item-wrapper"
                                                },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      class: _vm.$selectByLang(
                                                        "el-form-item-label90-w220",
                                                        "el-form-item-label100-w230"
                                                      ),
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "CargoMsg.Cargo_InvoiceNature"
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "cargo-advance-select",
                                                        {
                                                          attrs: {
                                                            no: "invoiceNature",
                                                            filterable: "",
                                                            cache: false,
                                                            disabled:
                                                              _vm.invoiceReadonly,
                                                            "default-value":
                                                              _vm.properties
                                                                .invoice
                                                                .invoiceNature,
                                                            "static-options":
                                                              _vm
                                                                .InvoiceConstant
                                                                .INVOICE_NATURE,
                                                            "tag-value": "code",
                                                            "tag-name": _vm.isZh
                                                              ? "chineseName"
                                                              : "englishName"
                                                          },
                                                          on: {
                                                            parentCallBack:
                                                              _vm.apInvoiceNatureChangeEvent
                                                          }
                                                        }
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.billingJob_taxRate"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input-number", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.invoiceReadonly ||
                                                        _vm.apTaxRateReadonly,
                                                      no: "102",
                                                      precision: 2,
                                                      step: 1,
                                                      min: 0,
                                                      max: 100,
                                                      "controls-position":
                                                        "right"
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.taxRateChangeHandler
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .taxRate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "taxRate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.taxRate"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.invoice_taxAmount"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input-number", {
                                                    attrs: {
                                                      disabled:
                                                        _vm.invoiceReadonly,
                                                      no: "103",
                                                      precision: 2,
                                                      step: 1,
                                                      min: -999999999999,
                                                      max: 999999999999,
                                                      "controls-position":
                                                        "right"
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.taxAmountChangeHandler
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .taxAmount,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "taxAmount",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.taxAmount"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  class: _vm.$selectByLang(
                                                    "el-form-item-label90-w220",
                                                    "el-form-item-label100-w230"
                                                  ),
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.invoice_approvedBy"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: true,
                                                      no: "104"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .auditor,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "auditor",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.auditor"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticClass:
                                                    "el-form-item-date-w130",
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.invoice_actualReceiptDate"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-date-picker", {
                                                    attrs: {
                                                      disabled: _vm.locked,
                                                      no: "105",
                                                      type: "date"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .actualReceiptDate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "actualReceiptDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.actualReceiptDate"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  staticClass:
                                                    "el-form-item-date-w130",
                                                  staticStyle: {
                                                    "padding-left": "20px"
                                                  },
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Payment.paymentPeriod"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-date-picker", {
                                                    attrs: {
                                                      disabled: _vm.locked,
                                                      no: "paymentTerm",
                                                      type: "date",
                                                      placeholder:
                                                        _vm.incomePayDate
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .paymentTerm,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "paymentTerm",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.paymentTerm"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "el-form-item-wrapper"
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  class: _vm.$selectByLang(
                                                    "el-form-item-textarea-label90-w350",
                                                    "el-form-item-textarea-label100-w360"
                                                  ),
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Invoice.invoice_notesOnReceipt"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: _vm.locked,
                                                      type: "textarea",
                                                      no: "106"
                                                    },
                                                    on: {
                                                      input:
                                                        _vm.markInvoiceRemarkModified
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .remark,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "remark",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.remark"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-form-item",
                                                {
                                                  class: _vm.$selectByLang(
                                                    "el-form-item-textarea-label90-w350",
                                                    "el-form-item-textarea-label120-w380"
                                                  ),
                                                  staticStyle: {
                                                    "margin-left": "50px"
                                                  },
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_FinancialRemarks"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      disabled: _vm.locked,
                                                      type: "textarea",
                                                      no: "107"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.properties.invoice
                                                          .remark2,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.properties
                                                            .invoice,
                                                          "remark2",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "properties.invoice.remark2"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        id: "dgCharge",
                        lazy: true,
                        label: _vm.$t("Invoice.invoice_chargeDetails"),
                        name: "chargeDetails"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "app-main-inner-row row-grid",
                          staticStyle: { height: "450px", padding: "0" }
                        },
                        [
                          _vm.visible && _vm.activeTabName === "chargeDetails"
                            ? _c("cargo-ag-grid", {
                                staticStyle: {
                                  width: "100%",
                                  "min-height": "450px"
                                },
                                attrs: {
                                  "grid-params": _vm.chargeGrid.gridParams,
                                  "grid-options": _vm.chargeGrid.gridOptions,
                                  "column-defs": _vm.chargeGrid.columnDefs,
                                  "row-data": _vm.chargeGridRowData,
                                  "config-module": "20220406"
                                },
                                on: {
                                  "update:gridParams": function($event) {
                                    return _vm.$set(
                                      _vm.chargeGrid,
                                      "gridParams",
                                      $event
                                    )
                                  },
                                  "update:grid-params": function($event) {
                                    return _vm.$set(
                                      _vm.chargeGrid,
                                      "gridParams",
                                      $event
                                    )
                                  },
                                  gridReady: _vm.onGridReady
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-end",
                            "padding-right": "10px",
                            "font-size": "12px",
                            "background-color": "#f5f7f7",
                            "flex-direction": "row"
                          }
                        },
                        [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("Invoice.invoice_total")
                              )
                            }
                          }),
                          _c("charge-currency-total-group", {
                            key: 1,
                            attrs: {
                              mode: "group",
                              type: "auto",
                              source: "invoiceDetail",
                              "data-field": "amount",
                              "rate-field": "invoiceRate",
                              "currency-field": "currency",
                              "ar-field": "isReceivable",
                              "data-provider": _vm.chargeGridRowData,
                              "amount-to-currency":
                                _vm.properties.invoice.currency,
                              "currency-conversion-in-invoices":
                                _vm.currencyConversionInInvoices
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  !_vm.lookView
                    ? _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            id: "dgFileAttachment",
                            lazy: true,
                            label: _vm.fileAttachmentTitle,
                            name: "fileAttachment"
                          }
                        },
                        [
                          _vm.visible
                            ? _c("file-attachment", {
                                attrs: { invoice: _vm.properties.invoice }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          !_vm.isBpm
            ? _c(
                "div",
                {
                  staticClass: "dense-btns",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "span",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !(_vm.properties.currentPage > 1),
                            no: "108"
                          },
                          on: { click: _vm.btPreClickHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_theLastPage")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !(
                              _vm.properties.currentPage <
                              _vm.properties.totalPage
                            ),
                            no: "109"
                          },
                          on: { click: _vm.btNextClickHandler }
                        },
                        [_vm._v(_vm._s(_vm.$t("Invoice.invoice_theNextPage")))]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "font-size": "14px",
                            "margin-left": "6px"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.properties.currentPage) +
                              " / " +
                              _vm._s(_vm.properties.totalPage)
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "cargo-button-group-slider",
                    { staticStyle: { flex: "1" }, attrs: { align: "right" } },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.lookView,
                              expression: "!lookView"
                            }
                          ]
                        },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.properties.invoice.ar,
                                  expression: "!properties.invoice.ar"
                                },
                                {
                                  name: "permission",
                                  rawName: "v-permission",
                                  value: [
                                    "button_ACInvoice_receiptAssociation"
                                  ],
                                  expression:
                                    "['button_ACInvoice_receiptAssociation']"
                                }
                              ],
                              attrs: {
                                type: "primary",
                                no: "InvoiceAssociation"
                              },
                              on: { click: _vm.showInvoicePoolDialog }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_InvoiceAssociation")
                                )
                              )
                            ]
                          ),
                          _vm.properties.invoice.ar &&
                          _vm.properties.toExoSystemYGSH &&
                          [2, 3, 4, 6, 7].includes(
                            _vm.properties.invoice.invoiceType
                          )
                            ? _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", no: "110" },
                                  on: { click: _vm.addEmailHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_SupplementaryInformation"
                                      )
                                    )
                                  )
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.properties.invoice.ar &&
                                    [2, 3, 4, 6, 7].includes(
                                      _vm.properties.invoice.invoiceType
                                    ),
                                  expression:
                                    "properties.invoice.ar && [2,3,4,6,7].includes(properties.invoice.invoiceType)"
                                }
                              ],
                              attrs: { type: "primary", no: "111" },
                              on: { click: _vm.updateInvoiceRemarkHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Invoice.invoice_updateRemark"))
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.properties.isEasyInoivceVietnam,
                                  expression: "!properties.isEasyInoivceVietnam"
                                }
                              ],
                              attrs: {
                                disabled:
                                  _vm.properties.invoice.jobSalesChannel ===
                                  "eTowerOne",
                                type: "primary",
                                no: "112"
                              },
                              on: {
                                click: _vm.differenceAdjustmentClickHandler
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Invoice.invoice_differenceAdjustment")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.properties.invoice.ar,
                                  expression: "properties.invoice.ar"
                                }
                              ],
                              attrs: { type: "primary", no: "113" },
                              on: { click: _vm.downloadClickHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("Invoice.invoice_downLoad")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.properties.invoice.ar &&
                                    !_vm.properties.isEasyInoivceVietnam,
                                  expression:
                                    "properties.invoice.ar && !properties.isEasyInoivceVietnam"
                                }
                              ],
                              attrs: {
                                type: "primary",
                                no: "114",
                                disabled: !_vm.enableSelectInoviceNo
                              },
                              on: { click: _vm.selectInvoiceEvent }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Invoice.invoice_selectInvoiceNo")
                                )
                              )
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: !_vm.enableSave,
                                no: "115"
                              },
                              on: { click: _vm.saveHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("Invoice.invoice_save")))]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "danger",
                                disabled: !_vm.enableDelete,
                                no: "invoiceDelete"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteHandler(false)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Invoice.invoice_delete")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.properties.invoice.ar,
                                  expression: "properties.invoice.ar"
                                },
                                {
                                  name: "permission",
                                  rawName: "v-permission",
                                  value: ["button_fmMakeInvoice_print"],
                                  expression: "['button_fmMakeInvoice_print']"
                                }
                              ],
                              attrs: {
                                type: "primary",
                                no: "116",
                                disabled: !_vm.enablePrint
                              },
                              on: { click: _vm.printHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("Invoice.invoice_print")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.properties.invoice.ar,
                                  expression: "properties.invoice.ar"
                                }
                              ],
                              attrs: {
                                type: "primary",
                                no: "117",
                                disabled: !_vm.enablePrint
                              },
                              on: { click: _vm.printAllHandler }
                            },
                            [_vm._v(_vm._s(_vm.$t("Invoice.invoice_printAll")))]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.properties.invoice.ar &&
                                    [2, 3, 6, 7].includes(
                                      _vm.properties.invoice.invoiceType
                                    ) &&
                                    !_vm.valInvoiceCodeIsEmpty,
                                  expression:
                                    "properties.invoice.ar && [2,3,6,7].includes(properties.invoice.invoiceType) && !valInvoiceCodeIsEmpty"
                                }
                              ],
                              attrs: {
                                type: "primary",
                                no: "119",
                                disabled: !_vm.enableInterfaceExport
                              },
                              on: { click: _vm.interfacePrintHandler }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Invoice.invoice_CATISPrint"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "span",
                    [
                      _c("el-button", { on: { click: _vm.closeHandler } }, [
                        _vm._v(_vm._s(_vm.$t("common.btn.close")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.isBpm
            ? _c(
                "template",
                { staticStyle: { height: "65px" }, slot: "footer" },
                [
                  _vm.isBpm
                    ? _c("approval-comments-and-btns", {
                        attrs: {
                          "process-info": _vm.processInfo,
                          records: _vm.records,
                          type: _vm.type,
                          "form-subtype":
                            _vm.MAKE_INVOICE_INTERNAL_INVOICE.code,
                          "application-dimension":
                            _vm.APPLICATION_DIMENSION_MAKE_INVOICE.code,
                          "dashboard-url": _vm.dashboardUrl
                        },
                        on: {
                          close: function($event) {
                            return _vm.$emit("close")
                          },
                          closeAndRefresh: function($event) {
                            return _vm.$emit("closeAndRefresh")
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        2
      ),
      _vm.adjustBalanceDialog.show
        ? _c("difference-adjustment-dialog", {
            attrs: {
              visible: _vm.adjustBalanceDialog.show,
              invoice: _vm.adjustBalanceDialog.invoice,
              "rbg-show-charge-detail":
                _vm.adjustBalanceDialog.rbgShowChargeDetail,
              location: _vm.location
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.adjustBalanceDialog, "show", $event)
              },
              differenceAdjustmentCallBackEvent:
                _vm.differenceAdjustmentCallBackEvent
            }
          })
        : _vm._e(),
      _vm.selectInvoiceDialog.show
        ? _c("invoice-no-selector-dialog", {
            attrs: {
              visible: _vm.selectInvoiceDialog.show,
              "invoice-type": _vm.selectInvoiceDialog.invoiceType,
              "invoice-count": _vm.selectInvoiceDialog.invoiceCount
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.selectInvoiceDialog, "show", $event)
              },
              selectedInvoiceNoCallBackEvent: _vm.selectedInvoiceNoCallBackEvent
            }
          })
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          "printed-callback": _vm.templateSelectorDialog.printedCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.remarkUpdateWindow.show
        ? _c("invoice-update-remark-window", {
            attrs: {
              visible: _vm.remarkUpdateWindow.show,
              "invoice-uuid": _vm.remarkUpdateWindow.invoiceUuid
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.remarkUpdateWindow, "show", $event)
              },
              updateRemarkCallBackEvent: _vm.updateRemarkCallBackHandler
            }
          })
        : _vm._e(),
      _vm.invoiceEmailWindow.visible
        ? _c("invoice-email-window", {
            ref: "invoiceEmailWindow",
            attrs: {
              visible: _vm.invoiceEmailWindow.visible,
              invoice: _vm.invoiceEmailWindow.invoice,
              "invoice-email": _vm.invoiceEmailWindow.email,
              "account-id": _vm.invoiceEmailWindow.accountId
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.invoiceEmailWindow, "visible", $event)
              },
              relationEmailSuccess: _vm.relationEmailCallBackHandler
            }
          })
        : _vm._e(),
      _vm.ewmDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.ewmDialog.visible,
                title: _vm.$t("Message.Prompt"),
                width: "400px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.ewmDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { display: "flex", "flex-direction": "column" }
                },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        "label-width": "75px",
                        "label-position": "right"
                      }
                    },
                    [
                      _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c("div", {
                          staticClass: "el-message-box__status el-icon-warning"
                        }),
                        _c("div", { staticClass: "el-message-box__message" }, [
                          _vm._v(
                            " " +
                              _vm._s(this.$t("Invoice.WeChatScanningAgain")) +
                              " "
                          )
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            margin: "0 auto",
                            width: "fit-content"
                          }
                        },
                        [
                          _c("vue-qr", {
                            staticClass: "vue-qr",
                            attrs: {
                              text: _vm.ewmDialog.ewm,
                              "logo-scale": 200,
                              size: 200
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        no: "Certified",
                        type: "primary",
                        disabled: _vm.ewmDialog.time
                      },
                      on: {
                        click: function($event) {
                          return _vm.realPersonAuthentication(true)
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.ewmDialog.time
                            ? _vm.$t("Invoice.Certified") +
                                "(" +
                                _vm.ewmDialog.time +
                                ")"
                            : _vm.$t("Invoice.Certified")
                        )
                      )
                    ]
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c("batch-submit-or-approve-dialog", {
        attrs: {
          visible: _vm.batchSubmitOrApproveDialog.visible,
          "row-data": _vm.batchSubmitOrApproveDialog.rowData,
          "is-submit": true
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.batchSubmitOrApproveDialog, "visible", $event)
          }
        }
      }),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.batchCheckingWindow.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "res-data": _vm.batchCheckingWindow.resData,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.invoicePoolDialog.visible
        ? _c("invoice-pool-dialog", {
            attrs: {
              visible: _vm.invoicePoolDialog.visible,
              "seller-tax-name-default-value":
                _vm.invoicePoolDialog.sellerTaxNameDefaultValue
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.invoicePoolDialog, "visible", $event)
              },
              confirm: _vm.invoiceAssociationHandle
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }